/*
 * Sentry 瀏覽器端錯誤監控（errors-only）。
 *   - Next 16 會自動載入這支 instrumentation-client.js（客戶端、hydration 前）。
 *   - 只有 build 時注入了 NEXT_PUBLIC_SENTRY_DSN 才啟用；沒有就完全不動（dev / 未設皆安全）。
 *   - 單一 Sentry 專案 javascript-nextjs（org esp-c7）；用 NEXT_PUBLIC_BRAND 當 environment + tag 分各站。
 *   - errors-only：tracesSampleRate=0（不收效能）、不開 Session Replay。
 *   DSN / release 由 scripts/build-brand.mjs 寫進 .env.production（見該檔 Sentry 段）。
 */
import * as Sentry from '@sentry/react'

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN

if (dsn) {
  const brand = process.env.NEXT_PUBLIC_BRAND || 'unknown'
  Sentry.init({
    dsn,
    environment: brand,
    release: process.env.NEXT_PUBLIC_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0,
    initialScope: { tags: { brand } },
  })
}
